import React from "react";

import { FooterContainer, FooterText } from "../styled-components/SignupLogin";

export const Footer = () => {
    return(
        <FooterContainer>
            <FooterText>
                Digital Organiser built by Claire Caudwell for the Technigo Bootcamp final project 2021
            </FooterText>
        </FooterContainer>
    );
};